import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { RecurringCost } from './../models/recurring-cost';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class RecurringCostService {
  constructor(private cm: CommunicationManagerService) {}

  getRecurringCost(companyId: string, recurringCostId: string) {
    return this.cm.get(`recurringCost/${recurringCostId}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  createRecurringCost(recurringCost: RecurringCost) {
    const clone = _.cloneDeep(recurringCost);
    return this.cm.postAndGetJson(`recurringCost`, clone, [
      { headerName: 'companyId', headerValue: recurringCost.company },
    ]);
  }

  convertCompanyCostToRecurringCost(
    companyCostId: string, 
    recurringData: { 
      frequency: string, 
      endDate: Date, 
      expectedAmount: number,
      company: string
    }) {
    return this.cm.postAndGetJson(`recurringCost/from-company-cost/${companyCostId}`, recurringData, [
      { headerName: 'companyId', headerValue: recurringData.company },
    ]);
  }

  updateRecurringCost(
    companyId: string,
    recurringCostId: string,
    recurringCostItem: any
  ) {
    const clone = _.cloneDeep(recurringCostItem);
    return this.cm.put(`recurringCost/${recurringCostId}`, clone, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  delete(recurringcostId: string, companyId: string) {
    return this.cm.delete(`recurringCost/${recurringcostId}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }
}
